import { styled } from '@mui/material/styles'
import { FC } from 'react'
import { FilterList, FilterListItem } from 'react-admin'

export const StatusFilter: FC = () => (
  <Root className={classes.root} label="filters.status" icon={undefined}>
    <FilterListItem
      className={classes.item}
      label="resources.uploads.status.PENDING"
      value={{ status: 'PENDING' }}
    />
    <FilterListItem
      className={classes.item}
      label="resources.uploads.status.WORKING"
      value={{ status: 'WORKING' }}
    />
    <FilterListItem
      className={classes.item}
      label="resources.uploads.status.COMPLETED"
      value={{ status: 'COMPLETED' }}
    />
    <FilterListItem
      className={classes.item}
      label="resources.uploads.status.ERROR"
      value={{ status: 'ERROR' }}
    />
  </Root>
)

const PREFIX = 'xxllncStatusFilter'

const classes = {
  root: `${PREFIX}-root`,
  item: `${PREFIX}-item`,
}

const Root = styled(FilterList)(({ theme }) => ({
  [`&.${classes.root}`]: {
    display: 'flex',
    flexDirection: 'column',
  },
  [`& .${classes.item}`]: {},
}))
